import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { Backdrop, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Header from '../../../../header';
import Footer from '../../../../footer';
import CustomInput from '../../../../../components/customInput';
import CustomButton from '../../../../../components/customButton';
import { useSelector } from 'react-redux';
import { langSelector } from '../../../../../store/langSlice';
import getEnvironement, { getLang } from '../../../../../environnement';
import CustomSelect from '../../../../../components/customSelect';
import { useNavigate } from 'react-router-dom';

function SoumissionConfirm({
  open,
  handleClose
}) {
  const navigate = useNavigate();
  const lang = useSelector(langSelector);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{paddingBottom: '0px'}}
    >
      <DialogTitle id="alert-dialog-title">
        <p className='text-2xl sm:text-3xl font-medium font-inter mt-5' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.soumission}</p>
        
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.soumissionContent[0]}</p><br/>
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.soumissionContent[1]}</p><br/>
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.soumissionContent[2]}</p><br/>
          <p className='text-2xl sm:text-3xl font-regular font-inter text-red' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.soumissionContent[3]}</p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <div className='flex justify-end px-5 w-full'>
          <div
            className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-[180px]'
            onClick={() => {
              handleClose();
              navigate('/');
            }}
          >
            <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.accord}</p>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  )
}

export default function Soumission({
  activeItem
}) {
  const [titre, setTitre] = useState('');
  const [auteur, setAuteur] = useState('');
  const [coAuteur, setCoAuteur] = useState('');
  const [typeSoumission, setTypeSoumission] = useState('');
  const [email, setEmail] = useState('');
  const [ville, setVille] = useState('');
  const [pays, setPays] = useState('');
  const [autrePays, setAutrePays] = useState('');
  const [specialite, setSpecialite] = useState('');
  const [resume, setResume] = useState('');
  const [nationalite, setNationalite] = useState('');
  const [profession, setProfession] = useState('');
  const [tel, setTel] = useState('');
  const [typeParticipation, setTypeParticipation] = useState('');

  const [titreError, setTitreError] = useState('');
  const [auteurError, setAuteurError] = useState('');
  const [coAuteurError, setCoAuteurError] = useState('');
  const [typeSoumissionError, setTypeSoumissionError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [villeError, setVilleError] = useState('');
  const [paysError, setPaysError] = useState('');
  const [autrePaysError, setAutrePaysError] = useState('');
  const [specialiteError, setSpecialiteError] = useState('');
  const [resumeError, setResumeError] = useState('');
  const [nationaliteError, setNationaliteError] = useState('');
  const [professionError, setProfessionError] = useState('');
  const [telError, setTelError] = useState('');
  const [typeParticipationError, setTypeParticipationError] = useState('');

  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [openSoumissionConfirm, setOpenSoumissionConfirm] = useState(false);

  const lang = useSelector(langSelector);

  const sendSoumission = async () => {
    const url = `${getEnvironement().API_URL}/soumissionFirstWorldCup`;
    const data = {
      lang,
      titre,
      auteur,
      coAuteur,
      typeSoumission: typeParticipation === 'Spéctateur' ? 'Spéctateur' : typeSoumission,
      email,
      pays,
      ville,
      autrePays: pays === 'Maroc' ? '-' : autrePays,
      specialite,
      resume: typeParticipation === 'Spéctateur' ? '-' : resume,
      nationalite,
      profession,
      typeParticipation,
      tel,
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    }
    setOpenBackdrop(true);
    await axios.post(url, data, config)
      .then(() => setOpenBackdrop(false))
      // .then(() => toast.success(getLang(lang).firstWorldCup.soumissionSuccess))
      .then(() => setOpenSoumissionConfirm(true))
      .then(() => {
        setTitre('');
        setAuteur('');
        setCoAuteur('');
        setTypeSoumission('');
        setEmail('');
        setPays('');
        setVille('');
        setAutrePays('');
        setSpecialite('');
        setTypeParticipation('');
        setResume('');
        setTitreError('');
        setAuteurError('');
        setCoAuteurError('');
        setTypeSoumissionError('');
        setEmailError('');
        setVilleError('');
        setPaysError('');
        setAutrePaysError('');
        setSpecialiteError('');
        setResumeError('');
        setNationaliteError('');
        setProfessionError('');
        setTypeParticipationError('');
        setTelError('');
      })
      .catch((err) => {
        console.log(err);
        setOpenBackdrop(false);
        if (err.response.data.errors) {
          toast.error(getLang(lang).firstWorldCup.soumissionError);
          err.response.data.errors.titre ? setTitreError(err.response.data.errors.titre[0]) : setTitreError('');
          err.response.data.errors.auteur ? setAuteurError(err.response.data.errors.auteur[0]) : setAuteurError('');
          err.response.data.errors.coAuteur ? setCoAuteurError(err.response.data.errors.coAuteur[0]) : setCoAuteurError('');
          err.response.data.errors.typeSoumission ? setTypeSoumissionError(err.response.data.errors.typeSoumission[0]) : setTypeSoumissionError('');
          err.response.data.errors.email ? setEmailError(err.response.data.errors.email[0]) : setEmailError('');
          err.response.data.errors.ville ? setVilleError(err.response.data.errors.ville[0]) : setVilleError('');
          err.response.data.errors.pays ? setPaysError(err.response.data.errors.pays[0]) : setPaysError('');
          err.response.data.errors.autrePays ? setAutrePaysError(err.response.data.errors.autrePays[0]) : setAutrePaysError('');
          err.response.data.errors.specialite ? setSpecialiteError(err.response.data.errors.specialite[0]) : setSpecialiteError('');
          err.response.data.errors.resume ? setResumeError(err.response.data.errors.resume[0]) : setResumeError('');
          err.response.data.errors.nationalite ? setNationaliteError(err.response.data.errors.nationalite[0]) : setNationaliteError('');
          err.response.data.errors.profession ? setProfessionError(err.response.data.errors.profession[0]) : setProfessionError('');
          err.response.data.errors.tel ? setTelError(err.response.data.errors.tel[0]) : setTelError('');
          err.response.data.errors.typeParticipation ? setTypeParticipationError(err.response.data.errors.typeParticipation[0]) : setTypeParticipationError('');
        }
      });
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <ToastContainer />
      <SoumissionConfirm
        open={openSoumissionConfirm}
        handleClose={() => setOpenSoumissionConfirm(false)}
      />
      <Backdrop
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.7)',
          color: '#A31732',
          zIndex: 2000
        }}
        open={openBackdrop}
        onClick={() => setOpenBackdrop(false)}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Header activeItem={activeItem} />
      <div className='3xl:flex 3xl:justify-center' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none'}}>
        <div className='3xl:w-[1200px] px-10 my-10'>
          <p className='font-inter text-primary font-medium text-2xl sm:text-3xl mb-6' style={{transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'}}>{getLang(lang).firstWorldCup.soumissionTitle}</p>
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.titre}
            value={titre}
            setValue={setTitre}
            isError={titreError !== ''}
            error={titreError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.auteur}
            value={auteur}
            setValue={setAuteur}
            isError={auteurError !== ''}
            error={auteurError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.coAuteur}
            value={coAuteur}
            setValue={setCoAuteur}
            isError={coAuteurError !== ''}
            error={coAuteurError}
          />
          <CustomInput
            type='tel'
            placeholder={getLang(lang).firstWorldCup.tel}
            value={tel}
            setValue={setTel}
            isError={telError !== ''}
            error={telError}
          />
          <CustomInput
            type='email'
            placeholder={getLang(lang).firstWorldCup.email}
            value={email}
            setValue={setEmail}
            isError={emailError !== ''}
            error={emailError}
          />
          <CustomSelect
            items={[
              {id: 2, value: 'Résident', label: getLang(lang).firstWorldCup.professionItems[1]},
              {id: 3, value: 'Spécialiste', label: getLang(lang).firstWorldCup.professionItems[2]},
              {id: 4, value: 'Para médical', label: getLang(lang).firstWorldCup.professionItems[3]},
            ]}
            placeholder={getLang(lang).firstWorldCup.profession}
            value={profession}
            setValue={setProfession}
            isError={professionError !== ''}
            error={professionError}
          />
          <CustomSelect
            items={[
              {id: 1, value: 'Afrique', label: getLang(lang).firstWorldCup.nationaliteItems[0]},
              {id: 2, value: 'Europe', label: getLang(lang).firstWorldCup.nationaliteItems[1]},
              {id: 3, value: 'Amérique', label: getLang(lang).firstWorldCup.nationaliteItems[2]},
              {id: 4, value: 'Asie', label: getLang(lang).firstWorldCup.nationaliteItems[3]},
            ]}
            placeholder={getLang(lang).firstWorldCup.nationalite}
            value={nationalite}
            setValue={setNationalite}
            isError={nationaliteError !== ''}
            error={nationaliteError}
          />
          <CustomSelect
            items={[
              {id: 1, value: 'Maroc', label: getLang(lang).firstWorldCup.paysItems[0]},
              {id: 2, value: 'Autre', label: getLang(lang).firstWorldCup.paysItems[1]},
            ]}
            placeholder={getLang(lang).firstWorldCup.pays}
            value={pays}
            setValue={setPays}
            isError={paysError !== ''}
            error={paysError}
          />
          {pays === 'Autre'
          && (
            <CustomInput
              type='text'
              placeholder={getLang(lang).firstWorldCup.pays}
              value={autrePays}
              setValue={setAutrePays}
              isError={autrePaysError !== ''}
              error={autrePaysError}
            />
          )}
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.ville}
            value={ville}
            setValue={setVille}
            isError={villeError !== ''}
            error={villeError}
          />
          <CustomInput
            type='text'
            placeholder={getLang(lang).firstWorldCup.specialite}
            value={specialite}
            setValue={setSpecialite}
            isError={specialiteError !== ''}
            error={specialiteError}
          />
          <CustomSelect
            items={[
              {id: 0, value: 'Participant', label: getLang(lang).firstWorldCup.typeParticipationItems[0]},
              {id: 1, value: 'Spéctateur', label: getLang(lang).firstWorldCup.typeParticipationItems[1]},
            ]}
            placeholder={getLang(lang).firstWorldCup.typeParticipation}
            value={typeParticipation}
            setValue={setTypeParticipation}
            isError={typeParticipationError !== ''}
            error={typeParticipationError}
          />
          {typeParticipation === 'Participant'
          && (
            <>
              <CustomSelect
                items={[
                  {id: 1, value: 'CO', label: getLang(lang).firstWorldCup.typeSoumissionItems[0]},
                  {id: 2, value: 'CA', label: getLang(lang).firstWorldCup.typeSoumissionItems[1]},
                  {id: 3, value: 'Scénario', label: getLang(lang).firstWorldCup.typeSoumissionItems[2]},
                ]}
                placeholder={getLang(lang).firstWorldCup.typeSoumission}
                value={typeSoumission}
                setValue={setTypeSoumission}
                isError={typeSoumissionError !== ''}
                error={typeSoumissionError}
              />
              <CustomInput
                type='textarea'
                placeholder={getLang(lang).firstWorldCup.resume}
                limit
                messagePlusLimirWord={getLang(lang).firstWorldCup.messagePlusLimirWord}
                value={resume}
                setValue={setResume}
                isError={resumeError !== ''}
                error={resumeError}
              />
            </>
          )}
          <CustomButton
            value={getLang(lang).firstWorldCup.envoyer}
            handelClick={sendSoumission}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
}
